// extracted by mini-css-extract-plugin
export var blink = "_ax-2";
export var cursor = "_ax-1";
export var reactMarkdown = "_ax-3";
export var streamingText = "_ax-0";